<script>
import Mobilebtn from './mobilebtn.svelte';
import MobileNavbar from '../reusableitems/mobileNavbar.svelte';
</script>

<section>
    <div class="navbar">
        <MobileNavbar />
      </div>
    <div class="main">
        <div class="technicalCreator">
            <p>TECHNICAL</p>
            <p id="rightalign">CREATORS</p>
        </div>
        <div>
            <div class = 'text1'>
                <p >Looking for something more exciting than a run of the mill job at FANG (or is it MANG now)?<br><br> 

                    Look no further. We are the infrastructure company for the next generation of internet. We’re changing all that using technology from the future. <br><br>
                    
                    We’re on a mission to turn it into a decentralized self sustaining community of like minded changemakers across the globe. <br><br><br>
                    
                    
                    Interested?</p>
            </div>
                <div class="button">
                    <Mobilebtn
                    height="9.346vw"
                    width= "65.421vw"
                    text="Join Technical Creators"
                    text2="Governace Council"
                    txtsize="2.804vw"
                    txtsize2="2.804vw"
                    txtcolor='#FFFFFF'
                    bgcolor='#DA22FF'
                    lineheight = "6vw"
                    state="Technical Creators"/>
                 </div>
        </div>
    </div>
</section>

<style>
     .navbar{
        width: 100%;
    position: fixed;
    z-index: 10;
    }
    .text1{
        position: absolute;
    top: 118.467vw;
    font-family: 'Orbitron';
    font-style: normal;
    font-weight: 400;
    font-size: 2.804vw;
    left: 0;
    width: 86.215vw;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0.06em;
    color: #F4EEEC;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    }
    .button{
        position: absolute;
        top: 179.682vw;
        left: 0;
        right: 0;
    }
    #rightalign {
        text-align: end;
        margin-top: -1vw;
    }
    .main {
        width: 100%;
        overflow: hidden;
        height: max(216.355vw, 100vh);
        background-image: url("images/technical-creatorMobile/bg.svg");
        background-repeat: no-repeat;
        background-size: cover;
    }
    .technicalCreator {
        position: absolute;
        top: 48.832vw;
        width: 100%;
    }

    p {
        margin: 0;
    }
    .technicalCreator p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 1000;
        font-size: 15.019vw;
        line-height: 93.5%;
        text-transform: uppercase;
        color: #da22ff;
        letter-spacing: -1vw;
    }
</style>
